export const en = {
    error: 'An error occurred, please try again',
    'remove-confirm': 'Do you really want to delete {product}?',
    'remove-success': 'Product successfully deleted'
};
